import { CLOUDCAT_MAX_ITEM_IDS } from 'constants/appConstants';
import { RECEIVE_HEART_COUNTS } from 'constants/reduxActions';

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { fetchSponsoredProducts, likeCounts } from 'apis/cloudcatalog';
import { getSymphonySearchComponents } from 'apis/mafia';
import { trackError } from 'helpers/ErrorUtils';
import {
  BEGIN_FETCH_SPONSORED_PRODUCTS,
  BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS,
  FETCH_SPONSORED_PRODUCT_HEART_LIST_ERROR,
  FETCH_SPONSORED_PRODUCTS_ERROR,
  FETCH_SPONSORED_PRODUCTS_SUCCESS,
  FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR,
  RECEIVE_SYMPHONY_SEARCH_COMPONENTS
} from 'store/ducks/search/types';

export function* workFetchSponsoredProducts({ payload }) {
  try {
    const { environmentConfig, filters } = yield select();
    const { api: { cloudcatalog } } = environmentConfig;
    const { term } = filters;
    const response = yield call(fetchSponsoredProducts, cloudcatalog, { key: term, ...payload });
    const data = yield response.json();
    yield put({ type: FETCH_SPONSORED_PRODUCTS_SUCCESS, payload: { sponsoredProducts: data } });
  } catch (error) {
    yield put({ type: FETCH_SPONSORED_PRODUCTS_ERROR, payload: { error } });
    yield call(trackError,'NON-FATAL', 'Could not retrieve sponsored products', error);
  }
}

export function* workFetchSponsoredProductHeartCounts() {
  try {
    const { environmentConfig, search: { sponsoredProducts } } = yield select();
    const { api: { cloudcatalog } } = environmentConfig;
    const styleIds = sponsoredProducts?.styles?.reduce((acc, product) => {
      if (
        !acc.includes(product.styleId) && // only push non-dupes
        acc.length < CLOUDCAT_MAX_ITEM_IDS // ensure we don't go over endpoint threshold in order to prevent 400s
      ) {
        acc.push(product.styleId);
      }
      return acc;
    }, []);
    if (styleIds) {
      const response = yield call(likeCounts, cloudcatalog, { styleIds, type: 'h' });
      const data = yield response.json();
      yield put({ type: RECEIVE_HEART_COUNTS, heartsList: data });
    }
  } catch (error) {
    yield put({ type: FETCH_SPONSORED_PRODUCT_HEART_LIST_ERROR, payload: { error } });
    yield call(trackError,'NON-FATAL', 'Could not retrieve sponsored product heart counts', error);
  }
}

export function* workFetchSymphonySearchComponents() {
  try {
    const { environmentConfig: { api: { mafia } }, client: { request }, cookies, filters: { term, breadcrumbs } } = yield select();
    // Currently in the beginning phase of bads, we don't want to display banners if a search terms is filtered down, so bail out early
    if (breadcrumbs?.length > 0) {
      return;
    }
    const response = yield call(getSymphonySearchComponents, mafia, { term }, cookies, request);
    const data = yield response.json();
    yield put({ type: RECEIVE_SYMPHONY_SEARCH_COMPONENTS, payload: { data } });
  } catch (error) {
    yield put({ type: FETCH_SYMPHONY_SEARCH_COMPONENTS_ERROR, payload: { error } });
    yield call(trackError, 'NON-FATAL', 'Could not retrieve symphony search components', error);
  }
}

export function* watchFetchSymphonySearchComponents() {
  yield takeLatest(BEGIN_FETCH_SYMPHONY_SEARCH_COMPONENTS, workFetchSymphonySearchComponents);
}

export function* watchFetchSponsoredProducts() {
  yield takeLatest(BEGIN_FETCH_SPONSORED_PRODUCTS, workFetchSponsoredProducts);
}

export function* watchFetchSponsoredProductHeartCounts() {
  yield takeLatest(FETCH_SPONSORED_PRODUCTS_SUCCESS, workFetchSponsoredProductHeartCounts);
}

export default [watchFetchSponsoredProducts, watchFetchSponsoredProductHeartCounts, watchFetchSymphonySearchComponents]
;
